export default "__VITE_ASSET__Cs52KapQ__"